module.exports = __webpack_public_path__ + "static/media/food.50289b79.jpg";